import { enforceFormat } from '../../../app/common/fields/phoneNumber/PhoneNumberFormatting';

export function formatPhoneNumForApiRequest(
    inputtedPhoneNum: string,
    savedPhoneNum: string | null,
): string {
    let enforcedMobilePhoneFormat = inputtedPhoneNum ? enforceFormat(inputtedPhoneNum) : '';
    enforcedMobilePhoneFormat = formatInvalidPhoneNumber(enforcedMobilePhoneFormat);
    enforcedMobilePhoneFormat = formatIdenticalPhoneNumbers(
        enforcedMobilePhoneFormat,
        savedPhoneNum,
    );

    return enforcedMobilePhoneFormat;
}

export function formatInvalidPhoneNumber(phoneNumber: string) {
    if (phoneNumInputIsNotValid(phoneNumber)) {
        return '';
    }
    return phoneNumber;
}

function phoneNumInputIsNotValid(enforcedMobilePhoneFormat: string): boolean {
    return enforcedMobilePhoneFormat.length < 5 || enforcedMobilePhoneFormat === 'undefined';
}

export function formatIdenticalPhoneNumbers(
    formattedInputtedPhoneNumber: string,
    savedPhoneNumber: string | null,
): string {
    // if the number editted after formatting is the same as what's read in
    // keep the original saved phone number
    if (!savedPhoneNumber) {
        return formattedInputtedPhoneNumber;
    }

    const formattedSavedPhoneNumber = enforceFormat(savedPhoneNumber);

    if (formattedSavedPhoneNumber === formattedInputtedPhoneNumber) {
        return savedPhoneNumber;
    }
    return formattedInputtedPhoneNumber;
}
